import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Request } from '../../../clientHttp/request';
import { HttpService } from '../../../clientHttp/http.service';
import { ApplymentModel } from './applyment.model';

@Injectable({
  providedIn: 'root'
})
export class GetApplymentService extends Request implements Resolve<GetApplymentService> {

  constructor(
    private http: HttpService,
    private applymentModel: ApplymentModel,
  ) {
    super();
  }

  private response: any = null;

  resolve(
    activatedRouteSnapshot: ActivatedRouteSnapshot,
  ): Observable<any> | Promise<any> | any {

    const domainOrigin = window.location.origin.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '');
    this.url = 'applyment/';
    this.data = {
      domain: `${domainOrigin}/${this.buildUriParams(activatedRouteSnapshot.params)}`
    };

    return this.http.post(this)
      .then((data) => this.response);
  }

  buildUriParams(params) {
    let response = '';
    response += params.uri1 ? '/' + params.uri1 : '';
    response += params.uri2 ? '/' + params.uri2 : '';
    response += params.uri3 ? '/' + params.uri3 : '';
    response += params.uri4 ? '/' + params.uri4 : '';
    response += params.uri5 ? '/' + params.uri5 : '';
    response += params.uri6 ? '/' + params.uri6 : '';
    response += params.uri7 ? '/' + params.uri7 : '';
    response += params.uri8 ? '/' + params.uri8 : '';
    response += params.uri9 ? '/' + params.uri9 : '';
    response += params.uri10 ? '/' + params.uri10 : '';
    response += params.uri ? '/' + params.uri : '';
    return response.indexOf('/') === 0 ? response.slice(1) : response;
  }

  successAction(data) {
    this.response = data;
    if (data && data.success) {
      this.applymentModel.setSelectiveProcess(data.data);
    } else {
      this.applymentModel.setSelectiveProcess(null);
    }
  }


  errorAction(error) {
  }
}
